import {
  LOGIN_PAGE_FIRST_NAME,
  LOGIN_PAGE_PHONE_NUMBER,
  LOGIN_PAGE_EMAIL,
  LOGIN_PAGE_PASSWORD,
  LOGIN_PAGE_SIGNIN,
  LOGIN_PAGE_SIGNUP,
  LOGIN_PAGE_VERIFY,
  LOGIN_HIDE_LOADER,
  LOGIN_SHOW_LOADER,
  LOGIN_SHOW_MESSAGE,
  LOGIN_HIDE_MESSAGE,
  LOGIN_PAGE_CHANGE_VERIFY,
  LOGOUT_USER,
  TOGGLE_HEADER,
  LOGOUT_USER_RESPONSE,
  LOGIN_PAGE_FORGOT_PASSWORD,
  LOGIN_PAGE_CONFIRM_PASSWORD,
  LOGIN_PAGE_RESET_PASSWORD,
  LOGIN_PAGE_FORGOT_PASSWORD_SUCCESS,
  USER_ACTIVATION,
  AUTH_SUCCESS,
} from "../constants/ActionTypes";

export const signIn = payload => ({
  type: LOGIN_PAGE_SIGNIN,
  payload,
});

export const signUp = payload => ({
  type: LOGIN_PAGE_SIGNUP,
  payload,
});

export const forgotPassword = payload => ({
  type: LOGIN_PAGE_FORGOT_PASSWORD,
  payload,
});

export const resetPassword = payload => ({
  type: LOGIN_PAGE_RESET_PASSWORD,
  payload,
});

export const firstnameInput = payload => ({
  type: LOGIN_PAGE_FIRST_NAME,
  payload,
});

export const phonenumberInput = payload => ({
  type: LOGIN_PAGE_PHONE_NUMBER,
  payload,
});

export const emailInput = payload => ({
  type: LOGIN_PAGE_EMAIL,
  payload,
});

export const passwordInput = payload => ({
  type: LOGIN_PAGE_PASSWORD,
  payload,
});

export const confirmPasswordInput = payload => ({
  type: LOGIN_PAGE_CONFIRM_PASSWORD,
  payload,
});

export const setVerify = payload => ({
  type: LOGIN_PAGE_VERIFY,
  payload,
});

export const changeVerify = () => ({
  type: LOGIN_PAGE_CHANGE_VERIFY,
});

export const hideLoader = () => ({
  type: LOGIN_HIDE_LOADER,
});

export const showLoader = () => ({
  type: LOGIN_SHOW_LOADER,
});

export const hideMessages = () => ({
  type: LOGIN_HIDE_MESSAGE,
});

export const showMessage = payload => ({
  type: LOGIN_SHOW_MESSAGE,
  payload,
});

export const logoutUser = () => ({
  type: LOGOUT_USER,
});

export const toggleHeader = payload => ({
  type: TOGGLE_HEADER,
  payload,
});

export const logoutUserResponse = payload => ({
  type: LOGOUT_USER_RESPONSE,
  payload,
});
export const forgotPasswordSuccess = payload => ({

  type: LOGIN_PAGE_FORGOT_PASSWORD_SUCCESS,
  payload,
});

export const userActivation = payload => ({
  type: USER_ACTIVATION,
  payload,
});

export const authSuccess = payload => ({
  type: AUTH_SUCCESS,
  payload,
});



// WEBPACK FOOTER //
// ./actions/LoginActions.js